import { render, staticRenderFns } from "./CouponAdd.vue?vue&type=template&id=6cd88064"
import script from "./CouponAdd.vue?vue&type=script&lang=js"
export * from "./CouponAdd.vue?vue&type=script&lang=js"
import style0 from "./CouponAdd.vue?vue&type=style&index=0&id=6cd88064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports